import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExperienceCardComponent } from './experience-card.component';

@NgModule({
  declarations: [ExperienceCardComponent],
  imports: [CommonModule],
  exports: [ExperienceCardComponent],
})
export class ExperienceCardModule {}
